import React from "react";
import { useFetchSeoSettings } from "../data/fetchSeoSettings";
import CheckBet from "../data/my-bets/checkbet/CheckBet";
import { SeoContext } from "../data/seo/SeoContextProvider";
import SeoMetaTags from "../data/seo/SeoMetaTags";
import { useHandleSeoSettings } from "../data/seo/seoUtils";
import { getConfiguration } from "../data/utils";

function ShowCheckBet(props) {
    const conf = getConfiguration();
    const seoContext = React.useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext && seoContext.pathname,props.isMobile,conf.seo);
    
    useHandleSeoSettings(seoSettingsState);
    return (
        <>
            <SeoMetaTags />
            <CheckBet />
        </>
    );
}

export default ShowCheckBet;
